import { validateEmail } from "../../../../utils/validationUtils";
import { COMPANY_OPTIONS } from "../../../../constants/companyDistributorData";

// ── LOB options per entity category ───────────────────────────────────────────
export const LOB_OPTIONS_CLIENT = [
  { value: "", label: "Select entity LOB type" },
  { value: "travel", label: "Travel" },
  { value: "auto", label: "Auto" },
  { value: "gadget", label: "Gadget" },
];

export const LOB_OPTIONS_SERVICE_PARTNER = [
  { value: "", label: "Select entity LOB type" },
  { value: "travel", label: "Travel" },
  { value: "auto", label: "Auto" },
  { value: "gadget", label: "Gadget" },
  { value: "travel_service", label: "Travel Service" },
  { value: "auto_service", label: "Auto Service" },
  { value: "gadget_service", label: "Gadget Service" },
];

export const LOB_OPTIONS_ALL = [
  { value: "", label: "Select entity LOB type" },
  { value: "travel", label: "Travel" },
  { value: "corporate", label: "Corporate" },
  { value: "auto", label: "Auto" },
  { value: "gadget", label: "Gadget" },
  { value: "travel_service", label: "Travel Service" },
  { value: "auto_service", label: "Auto Service" },
  { value: "gadget_service", label: "Gadget Service" },
  { value: "mobile_service", label: "Mobile Service" },
];

// ── AA Department options per entity category + LOB type ──────────────────────
export const DEPT_OPTIONS_BASE = [
  { value: "", label: "Select department function" },
];

const DEPT_SALES = [...DEPT_OPTIONS_BASE, { value: "Sales", label: "Sales" }];
const DEPT_OPS = [
  ...DEPT_OPTIONS_BASE,
  { value: "Purchase", label: "Purchase" },
  { value: "Marketing", label: "Marketing" },
  { value: "Operation", label: "Operation" },
];
const DEPT_CORP = [
  ...DEPT_OPTIONS_BASE,
  { value: "HR", label: "HR" },
  { value: "IT", label: "IT" },
  { value: "Finance", label: "Finance" },
];

export const AA_DEPT_MAP = {
  client: { travel: DEPT_SALES, auto: DEPT_SALES, gadget: DEPT_SALES },
  "Service Partner": {
    travel: DEPT_OPS,
    auto: DEPT_OPS,
    gadget: DEPT_OPS,
    travel_service: DEPT_OPS,
    auto_service: DEPT_OPS,
    gadget_service: DEPT_OPS,
  },
  corporate: { corporate: DEPT_CORP },
};

// ──  TODO: Primary form fields (dont change now here this all fileds have fixed ) ────────────────────────────────────────────────────────
export const clientFormFields = [
  { name: "sectionPrimaryDetails", type: "section", label: "Primary Details" },
  {
    name: "parentCode",
    label: "Parent",
    type: "select",
    required: false,
    section: "entityInfo",
    options: COMPANY_OPTIONS,
  },

  {
    name: "entityCategory",
    label: "Entity Category",
    type: "select",
    required: true,
    section: "entityInfo",
    options: [
      { value: "", label: "Select entity category" },
      { value: "Service Partner", label: "Service Partner" },
      { value: "client", label: "Client" },
    ],
  },
  {
    name: "EntityName",
    label: "Entity Name",
    type: "text",
    placeholder: "Please enter entity name",
    required: true,
    section: "entityInfo",
  },
  {
    name: "entityLOBType",
    label: "Entity LOB Type",
    type: "select",
    required: true,
    section: "entityInfo",
    options: LOB_OPTIONS_ALL, // overridden dynamically in renderField
  },

  {
    name: "aaDepartmentFunction",
    label: "AA - Department Function",
    type: "select",
    required: true,
    section: "entityInfo",
    options: DEPT_OPTIONS_BASE,
  },
  // ── Contact Person ───────────────────────────────────────────────────────────
  {
    name: "sectionContactPerson",
    type: "section",
    label: "Contact Person Details",
  },
  {
    name: "contactPersonEmail",
    label: "E-mail address",
    type: "email",
    placeholder: "Enter email address",
    required: true,
    section: "contactPerson",
    validation: validateEmail,
  },
  {
    name: "spocEmailAddress",
    label: "SPOC E-mail address",
    type: "email",
    placeholder: "Enter SPOC email address",
    required: true,
    section: "contactPerson",
    validation: validateEmail,
  },
  {
    name: "selectedrequirekyc",
    label: "Require KYC",
    type: "select",
    required: true,
    section: "entityInfo",

    options: [
      { value: "", label: "Select option" },
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ],
  },
];
